import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.createPOPDFLabelSet.presenters.createPOPDFLabelSetFormPresenter`

export default defineMessages({
  createButton: {
    id: `${scope}.createButton`,
    defaultMessage: 'Create',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: '{name} label has been created',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to create the label set.',
  },
})
